export default __webpack_public_path__ + "97fcc9359e958fd1ad2afc7eb4ea3536.svg";